import React, { useState, useEffect } from "react";
import logo from "../logo.png";
import "../App.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import lock from "../lock.svg";
import download from "../download.svg";
import unLock from "../unlock.png";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useParams } from "react-router";
import axios from "axios";
import { scrollByOptions, tabName } from "../utils/constants";
import InputMask from "react-input-mask";

let apiUrl = process.env.REACT_APP_MEDIA_API;

const downloadInitialState = {};

tabName.forEach((tab) => {
  downloadInitialState[tab] = true;
});

const Pictures = (props) => {
  const [activeTab, setActiveTab] = useState(tabName[0]);
  const [apiError, setApiError] = useState(false);
  const [data, setData] = useState(null);
  const [paymentData, setPaymentData] = useState({});
  const [productPackage, setProductPackage] = useState({});
  const [payError, setPayError] = useState("");
  const [isPaymentApiLoading, setIsPaymentApiLoading] = useState(false);

  const [showPaymentInterface, setShowPaymentInterface] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState("");

  const [showDownloadText, setShowDownloadText] =
    useState(downloadInitialState);

  const { slotId } = useParams();
  useEffect(() => {
    if (slotId) {
      const url = `${apiUrl}/mediaForDelivery/${slotId}`;
      axios
        .get(url)
        .then((resp) => {
          if (
            resp.data.insidePhoto ||
            resp.data.outsidePhoto ||
            resp.data.video
          ) {
            if (!resp.data.insidePhoto) {
              if (!resp.data.outsidePhoto) {
                setActiveTab(tabName[2]);
              } else {
                setActiveTab(tabName[1]);
              }
            }
            if (
              resp.data.upgradeOptions &&
              resp.data.upgradeOptions.length > 0
            ) {
              setProductPackage(resp.data.upgradeOptions[0]);
            }
            setData(resp.data);
          } else if (resp.data.expiryMessage) {
            setData(resp.data);
          } else if (!resp.data.success) {
            setApiError("User id invalid.");
          }
        })
        .then((e) => {
          console.log(e);
        });
    } else {
      setApiError("No user id present.");
    }
  }, []);

  const changeTab = (e, d) => {
    let target = e.target;
    if (target.tagName === "IMG") {
      target = target.parentElement;
    }
    if (target.classList.contains(tabName[0])) {
      if (activeTab !== tabName[0]) {
        setActiveTab(tabName[0]);
      }
    } else if (target.classList.contains(tabName[1])) {
      if (activeTab !== tabName[1]) {
        setActiveTab(tabName[1]);
      }
    } else if (target.classList.contains(tabName[2])) {
      if (activeTab !== tabName[2]) {
        setActiveTab(tabName[2]);
      }
    } else if (target.classList.contains(tabName[3])) {
      if (activeTab !== tabName[3]) {
        setActiveTab(tabName[3]);
      }
    }
  };

  const setPackage = (pkg) => {
    setProductPackage(pkg);
  };

  const onPaymentDetailsChange = (e) => {
    let name = e.target.getAttribute("name"),
      value = name === "terms" ? e.target.checked : e.target.value;

    setPayError("");
    setPaymentData({ ...paymentData, [name]: value });
  };

  const onBuyClick = () => {
    if (!showPaymentInterface) {
      setShowPaymentInterface(true);
    }
    setTimeout(() => {
      // it scrolls to bottom
      document.documentElement.scrollBy(scrollByOptions);
      document.body.scrollBy(scrollByOptions);
    }, 200);
  };

  const onPay = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isPaymentApiLoading) {
      return;
    }
    if (!paymentData.nameOnTheCard) {
      setPayError("Please enter card name.");
    } else if (!paymentData.expiryDate) {
      setPayError("Please enter expiry.");
    } else if (!paymentData.cvv) {
      setPayError("Please enter cvv.");
    } else if (!paymentData.address) {
      setPayError("Please enter address.");
    } else if (!paymentData.zipCode) {
      setPayError("Please enter zip code.");
    } else if (!paymentData.terms) {
      setPayError("Please check mark terms.");
    } else {
      const url = `${apiUrl}/upgrade`;
      setIsPaymentApiLoading(true);
      setPayError("");
      axios
        .post(url, {
          slotId,
          existingProduct: data.existingProduct,
          optionName: productPackage.name,
          price: productPackage.cost,
          ...paymentData,
          terms: undefined,
        })
        .then((resp) => {
          if (resp.data.success) {
            setPaymentSuccess("Successfully upgraded, reloading the page ...");

            setTimeout(() => {
              window.location.reload();
            }, 5000);
          } else {
            setPayError(resp.data.message);
            setIsPaymentApiLoading(false);
          }

          console.log(resp);
        })
        .catch((e) => {
          setIsPaymentApiLoading(false);

          console.log(e);
        });
    }
  };

  const changeDownloadText = () => {
    setShowDownloadText({ ...showDownloadText, [activeTab]: false });
  };

  let mediaType =
    activeTab === "insidePhoto"
      ? "selfies"
      : activeTab === "outsidePhoto"
      ? "pano"
      : activeTab;

  return (
    <div className="App">
      <header className="App-header">
        <div>
          <img src={logo} className="app-logo" alt="logo" />
          {apiError && <h2 className="error">{apiError}</h2>}
          {data?.expired ? (
            <p className="expiryMessage">{data?.expiryMessage}</p>
          ) : null}
        </div>
        {apiError || !data ? null : (
          <>
            <div className="tabWrapper">
              {data?.insidePhoto && (
                <button
                  onClick={changeTab}
                  className={`btn-tab ${tabName[0]} ${
                    activeTab === tabName[0] ? "active" : ""
                  }`}
                >
                  Selfie{" "}
                  {data?.insidePhoto?.hasPaid ? null : (
                    <img src={lock} alt="" />
                  )}
                </button>
              )}
              {data?.outsidePhoto && (
                <button
                  onClick={changeTab}
                  className={`btn-tab ${tabName[1]} ${
                    activeTab === tabName[1] ? "active" : ""
                  }`}
                >
                  Pano{" "}
                  {data?.outsidePhoto?.hasPaid ? null : (
                    <img src={lock} alt="" />
                  )}
                </button>
              )}

              {data?.video && (
                <button
                  onClick={changeTab}
                  className={`btn-tab  ${tabName[2]} ${
                    activeTab === tabName[2] ? "active" : ""
                  }`}
                >
                  Video{" "}
                  {data?.video?.hasPaid ? null : <img src={lock} alt="" />}
                </button>
              )}

              {data?.upgradeOptions && data?.upgradeOptions.length > 0 && (
                <button
                  onClick={changeTab}
                  className={`btn-tab  ${tabName[3]} ${
                    activeTab === tabName[3] ? "active" : ""
                  }`}
                >
                  {data?.existingProduct === "NONE" ? "Purchase" : "Upgrade"}{" "}
                </button>
              )}
            </div>
            {data &&
              data[activeTab] &&
              data[activeTab]?.hasPaid &&
              data[activeTab].deliveryURL && (
                <div className="downButton">
                  {showDownloadText[activeTab] ? (
                    <>
                      <div onClick={changeDownloadText}>
                        <a
                          className="btn btn-download"
                          href={data[activeTab].deliveryURL}
                          download
                          rel="noreferrer"
                        >
                          <img src={download} alt="" /> Download {mediaType}
                        </a>
                      </div>
                      {!data?.expired ? (
                        <p className="simple">{data?.expiryMessage}</p>
                      ) : null}
                    </>
                  ) : (
                    <h4>Downloading {mediaType} to your downloads folder</h4>
                  )}
                </div>
              )}
          </>
        )}
      </header>

      {data && activeTab === "insidePhoto" && data[activeTab] ? (
        <Photo data={data} activeTab={activeTab} setActiveTab={setActiveTab} />
      ) : null}

      {data && activeTab === "outsidePhoto" && data[activeTab] ? (
        <Photo data={data} activeTab={activeTab} setActiveTab={setActiveTab} />
      ) : null}

      {data && activeTab === "video" && data[activeTab] && (
        <Video data={data} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
      {data && activeTab === "upgradeOptions" &&
        (data.expired
          ? null
          : data[activeTab] &&
            data[activeTab].length > 0 && (
              <>
                <div className="productPackageWrapper mb-5">
                  {data[activeTab].map((option) => (
                    <div
                      className="packBox"
                      onClick={(e) => setPackage(option)}
                      key={option.name}
                    >
                      <div
                        className={
                          productPackage.name === option.name
                            ? "packBoxinner active"
                            : "packBoxinner"
                        }
                      >
                        <div className="pacradio">
                          <span>radio</span>
                          <div className="packContent">
                            <h3>{option.title}</h3>
                            <p>{option.text}</p>
                          </div>
                        </div>

                        <div className="pacPrice">
                          <h4>
                            <span>$</span>
                            {option.cost}
                          </h4>
                        </div>
                      </div>
                    </div>
                  ))}

                  {showPaymentInterface || (
                    <div className="submitWrapper">
                      <input
                        type="submit"
                        value="Buy Now!"
                        className="submitButton"
                        onClick={onBuyClick}
                      />
                    </div>
                  )}
                </div>

                {showPaymentInterface && (
                  <form className="formWrpper" onSubmit={onPay}>
                    <div className="halfWidthInputWrapper">
                      <div className="formhalfEle">
                        <label>Name on Card:</label>
                        <input
                          type="text"
                          name="nameOnTheCard"
                          onChange={onPaymentDetailsChange}
                        />
                      </div>
                      <div className="formhalfEle">
                        <label>Card Number:</label>
                        <InputMask
                          mask="9999 9999 9999 9999"
                          name="cardNumber"
                          type="tel"
                          onChange={onPaymentDetailsChange}
                        ></InputMask>
                      </div>
                    </div>

                    <div className="halfWidthInputWrapper">
                      <div className="formhalfEle">
                        <label>Expiry:</label>
                        <InputMask
                          mask="99/99"
                          name="expiryDate"
                          type="tel"
                          onChange={onPaymentDetailsChange}
                        ></InputMask>
                      </div>

                      <div className="formhalfEle">
                        <label>CCV:</label>
                        <input
                          name="cvv"
                          type="tel"
                          onChange={onPaymentDetailsChange}
                        />
                      </div>
                    </div>

                    <div className="fullWidthInputWrapper">
                      <label>Address:</label>
                      <input
                        type="text"
                        name="address"
                        onChange={onPaymentDetailsChange}
                      />
                    </div>

                    <div className="fullWidthInputWrapper">
                      <label>Zip Code:</label>
                      <input
                        type="tel"
                        name="zipCode"
                        onChange={onPaymentDetailsChange}
                      />
                    </div>
                    <label className="checkBoxWrapper">
                      I understand this payment is final and non refundable
                      <input
                        type="checkbox"
                        name="terms"
                        onChange={onPaymentDetailsChange}
                      />
                      <span className="checkmark"></span>
                    </label>

                    <p className="error">
                      {payError}
                      <span className="success">{paymentSuccess}</span>
                    </p>

                    <div className="submitWrapper">
                      <input
                        disabled={isPaymentApiLoading}
                        type="submit"
                        value={`Pay ${
                          productPackage.cost ? `$${productPackage.cost}` : ""
                        } Now`}
                        className="submitButton"
                      />
                    </div>
                  </form>
                )}
              </>
          )
        )
      }

      {/* Show video gif and pano gif for blurred response to cache */}
      {data && (
        <div className="hide">
          {data["video"] && data["video"]?.blur && (
            <img alt="" src={data["video"]?.blur} />
          )}
          {data["outsidePhoto"] && data["outsidePhoto"]?.blur && (
            <img alt="" src={data["outsidePhoto"]?.blur} />
          )}
        </div>
      )}
    </div>
  );
};

const UpgradeText = (props) => {
  return (
    <>
      <p className="notpaidError">
        <img src={unLock} alt="" />
        Please{" "}
        <span
          onClick={() => {
            props.setActiveTab(tabName[3]);
          }}
        >
          {props.existingProduct === "NONE" ? "purchase" : "upgrade"}
        </span>{" "}
        to unlock this content.
      </p>
      <div className="picturesList">
        <img
          className="loader-gif"
          alt=""
          src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Youtube_loading_symbol_1_(wobbly).gif"
        />
        <LazyLoadImage
          delayMethod="debounce"
          effect="blur"
          alt=""
          loading="lazy"
          src={props.gifUrl}
        />
      </div>
    </>
  );
};
const Photo = ({ data, activeTab, setActiveTab }) => {
  return data[activeTab]?.hasPaid ? (
    <div className="picturesList">
      {data[activeTab].files.map((url, i) => (
        <LazyLoadImage
          delayMethod="debounce"
          key={i}
          effect="blur"
          alt=""
          loading="lazy"
          src={url}
        />
      ))}
    </div>
  ) : (
    <UpgradeText
      existingProduct={data?.existingProduct}
      setActiveTab={setActiveTab}
      gifUrl={data[activeTab]?.blur}
    />
  );
};

const Video = ({ data, activeTab, setActiveTab }) => {
  return (
    <>
      {data[activeTab].previewURL || data[activeTab].deliveryURL ? (
        <video
          controls
          src={data[activeTab].previewURL || data[activeTab].deliveryURL}
        ></video>
      ) : data[activeTab]?.blur && !data[activeTab]?.hasPaid ? (
        <UpgradeText
          existingProduct={data?.existingProduct}
          setActiveTab={setActiveTab}
          gifUrl={data[activeTab]?.blur}
        />
      ) : !data[activeTab].hasProcess ? (
        <p className="notpaidError">
          {data[activeTab].message ||
            "The video is being processed.Please check back in sometime."}
        </p>
      ) : null}
    </>
  )
}

export default Pictures;
